// Daftar referensi resmi kependudukan Indonesia (standar Dukcapil / Permendagri).
// Ditulis HURUF KAPITAL agar seragam dengan format Kartu Keluarga (KK) & KTP,
// dan agar cocok langsung dengan hasil pindai KK.

export const GENDERS = ["LAKI-LAKI", "PEREMPUAN"];

export const RELIGIONS = [
  "ISLAM", "KRISTEN", "KATOLIK", "HINDU", "BUDDHA", "KONGHUCU",
  "KEPERCAYAAN TERHADAP TUHAN YME",
];

export const MARITAL = ["BELUM KAWIN", "KAWIN", "CERAI HIDUP", "CERAI MATI"];

export const BLOOD = [
  "A", "B", "AB", "O", "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "TIDAK TAHU",
];

export const EDUCATION = [
  "TIDAK/BELUM SEKOLAH", "BELUM TAMAT SD/SEDERAJAT", "TAMAT SD/SEDERAJAT",
  "SLTP/SEDERAJAT", "SLTA/SEDERAJAT", "DIPLOMA I/II", "AKADEMI/DIPLOMA III/S. MUDA",
  "DIPLOMA IV/STRATA I", "STRATA II", "STRATA III",
];

export const RELATIONSHIP = [
  "KEPALA KELUARGA", "SUAMI", "ISTRI", "ANAK", "MENANTU", "CUCU",
  "ORANG TUA", "MERTUA", "FAMILI LAIN", "PEMBANTU", "LAINNYA",
];

export const CITIZENSHIP = ["WNI", "WNA"];

// Daftar lengkap Jenis Pekerjaan sesuai standar Dukcapil (Permendagri).
export const OCCUPATION = [
  "BELUM/TIDAK BEKERJA", "MENGURUS RUMAH TANGGA", "PELAJAR/MAHASISWA", "PENSIUNAN",
  "PEGAWAI NEGERI SIPIL (PNS)", "TENTARA NASIONAL INDONESIA (TNI)", "KEPOLISIAN RI (POLRI)",
  "PERDAGANGAN", "PETANI/PEKEBUN", "PETERNAK", "NELAYAN/PERIKANAN", "INDUSTRI", "KONSTRUKSI",
  "TRANSPORTASI", "KARYAWAN SWASTA", "KARYAWAN BUMN", "KARYAWAN BUMD", "KARYAWAN HONORER",
  "BURUH HARIAN LEPAS", "BURUH TANI/PERKEBUNAN", "BURUH NELAYAN/PERIKANAN", "BURUH PETERNAKAN",
  "PEMBANTU RUMAH TANGGA", "TUKANG CUKUR", "TUKANG LISTRIK", "TUKANG BATU", "TUKANG KAYU",
  "TUKANG SOL SEPATU", "TUKANG LAS/PANDAI BESI", "TUKANG JAHIT", "TUKANG GIGI", "PENATA RIAS",
  "PENATA BUSANA", "PENATA RAMBUT", "MEKANIK", "SENIMAN", "TABIB", "PARAJI", "PERANCANG BUSANA",
  "PENTERJEMAH", "IMAM MASJID", "PENDETA", "PASTOR", "WARTAWAN", "USTADZ/MUBALIGH", "JURU MASAK",
  "PROMOTOR ACARA", "ANGGOTA DPR-RI", "ANGGOTA DPD", "ANGGOTA BPK", "PRESIDEN", "WAKIL PRESIDEN",
  "ANGGOTA MAHKAMAH KONSTITUSI", "ANGGOTA KABINET/KEMENTERIAN", "DUTA BESAR", "GUBERNUR",
  "WAKIL GUBERNUR", "BUPATI", "WAKIL BUPATI", "WALIKOTA", "WAKIL WALIKOTA",
  "ANGGOTA DPRD PROVINSI", "ANGGOTA DPRD KABUPATEN/KOTA", "DOSEN", "GURU", "PILOT", "PENGACARA",
  "NOTARIS", "ARSITEK", "AKUNTAN", "KONSULTAN", "DOKTER", "BIDAN", "PERAWAT", "APOTEKER",
  "PSIKIATER/PSIKOLOG", "PENYIAR TELEVISI", "PENYIAR RADIO", "PELAUT", "PENELITI", "SOPIR",
  "PIALANG", "PARANORMAL", "PEDAGANG", "PERANGKAT DESA", "KEPALA DESA", "BIARAWATI",
  "WIRASWASTA", "BURUH", "LAINNYA",
];
